import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { ApiError, isTurnstileError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { AuthShell } from "../components/AuthShell";
import { RATE_LIMIT_ERROR_MESSAGE, Turnstile, TURNSTILE_ERROR_MESSAGE, turnstileEnabled } from "../components/Turnstile";
import { Button, Field, Input, ErrorText } from "../components/ui";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password, turnstileToken);
      void navigate("/");
    } catch (err) {
      if (isTurnstileError(err)) setError(TURNSTILE_ERROR_MESSAGE);
      else if (err instanceof ApiError && err.status === 429) setError(RATE_LIMIT_ERROR_MESSAGE);
      else setError("Email o contraseña incorrectos.");
      // Turnstile tokens are single-use: get a fresh challenge for the next try.
      setTurnstileToken("");
      setAttempt((n) => n + 1);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title="Inicia sesión" subtitle="Accede al CRM o al portal de cliente">
      <form onSubmit={(e) => void onSubmit(e)} className="flex flex-col gap-4">
        {error && <ErrorText>{error}</ErrorText>}
        <Field label="Email">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
        </Field>
        <Field label="Contraseña">
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
        </Field>
        <Turnstile key={attempt} onToken={setTurnstileToken} />
        <Button type="submit" disabled={busy || (turnstileEnabled && !turnstileToken)}>{busy ? "Entrando…" : "Entrar"}</Button>
      </form>
    </AuthShell>
  );
}
